"use client";

import cx from "classnames";
import type React from "react";
import styles from "./styles.module.css";

// Simplified props interface / Упрощенный интерфейс пропсов
type IconButtonProps = {
	icon: React.ReactNode;
	onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	color?: "like" | "gallery" | "default";
	disabled?: boolean;
	className?: string;
	ariaLabel?: string;
	text?: string;
	tooltip?: string;
	tooltipPosition?: "top" | "bottom" | "right" | "left";
};

// Simplified component / Упрощенный компонент
const IconButton: React.FC<IconButtonProps> = ({
	icon,
	onClick = () => {},
	color = "default",
	disabled = false,
	className = "",
	ariaLabel = "",
	text,
	tooltip,
	tooltipPosition = "bottom",
}) => (
	<button
		className={cx(
			styles.iconButton,
			color === "gallery" && styles.galleryButton,
			color === "like" && styles.likeButton,
			className,
		)}
		disabled={disabled}
		type="button"
		onClick={(e) => {
			e.preventDefault();
			e.stopPropagation();
			onClick?.();
		}}
		aria-label={ariaLabel}
		data-tooltip={tooltip}
		data-tooltip-position={tooltipPosition || "bottom"}
	>
		{icon}
		{text && <span className="icon-button-text">{text}</span>}
	</button>
);

export default IconButton;
